import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(CategoryScale, ArcElement, Tooltip, Legend);

const PiChart = ({ data, currency }) => {
  const options = {
    responsive: true,
    //   maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return currency ? `${currency}${Number(value).toFixed(2)}` : value;
          },
        },
      },
    },
  };

  return <Pie data={data} options={options}/>;
};

export default PiChart;
